export const BASE_URL = 'http://198.38.88.235:8002';
